import { useEffect, useState } from "react";
import BaseModalApp from "../../../components/modals/app-modals/BaseModalApp";
import { ApplicationButton, ApplicationField, ApplicationStateRegion } from "../../../components/application";

export default function PerceptualTargetDialog({ isOpen, onCancel, onSave }) {
  const [form, setForm] = useState({ name: "", instruction: "", description: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (isOpen) {
      setForm({ name: "", instruction: "", description: "" });
      setError("");
    }
  }, [isOpen]);

  async function submit(event) {
    event.preventDefault();
    if (!form.name.trim() || !form.instruction.trim()) {
      setError("Add a name and participant instruction.");
      return;
    }
    try {
      setSaving(true);
      setError("");
      await onSave(form);
    } catch {
      setError("The perceptual target could not be saved. Try again.");
    } finally { setSaving(false); }
  }

  return (
    <BaseModalApp isOpen={isOpen} onRequestClose={saving ? undefined : onCancel} contentLabel="Create a custom perceptual target" size="500px">
      <form className="av-target-dialog" onSubmit={submit}>
        <div><h2>Create a custom perceptual target</h2><p>Create a reusable description of what participants should judge.</p></div>
        {error ? <ApplicationStateRegion status="error" message={error} /> : null}
        <ApplicationField autoFocus label="Name" value={form.name} maxLength={120} onChange={event => setForm(current => ({ ...current, name: event.target.value }))} />
        <label className="av-authoring-textarea"><span>Participant instruction</span><textarea value={form.instruction} maxLength={1000} onChange={event => setForm(current => ({ ...current, instruction: event.target.value }))} /></label>
        <label className="av-authoring-textarea"><span>Optional description</span><textarea value={form.description} maxLength={2000} onChange={event => setForm(current => ({ ...current, description: event.target.value }))} /></label>
        <div className="av-target-dialog__actions">
          <ApplicationButton variant="quiet" disabled={saving} onClick={onCancel}>Cancel</ApplicationButton>
          <ApplicationButton type="submit" disabled={saving}>{saving ? "Saving…" : "Save and use"}</ApplicationButton>
        </div>
      </form>
    </BaseModalApp>
  );
}
